module.exports = __webpack_public_path__ + "static/media/blog-post-thumb-1.2f249777.jpg";